// Product discovery defaults; explicit user filters remain authoritative.
const configured = Number(process.env.REACT_APP_CSB_DEFAULT_MIN_ODDS ?? "1.50");
export const DEFAULT_MIN_ODDS = Number.isFinite(configured) && configured >= 1.01 && configured <= 20 ? configured : 1.50;
